<div class="cta-block">
  @if (eyebrow) {
    <span class="cta-block__eyebrow">{{ eyebrow }}</span>
  }
  <h2 class="cta-block__title">{{ title }}</h2>
  @if (text) {
    <p class="cta-block__text">{{ text }}</p>
  }
  <ng-content></ng-content>
  @if (kind === 'internal') {
    <a class="apple-cta apple-cta--blue" [routerLink]="routerLinkValue">
      <span>{{ buttonLabel }}</span>
      <icon name="navigate_next"></icon>
    </a>
  } @else {
    <a class="apple-cta apple-cta--blue" [href]="buttonUrl" rel="noopener">
      <span>{{ buttonLabel }}</span>
      <icon name="navigate_next"></icon>
    </a>
  }
</div>
